import { render } from "./blogWrappers.vue?vue&type=template&id=0b0075b3&scoped=true"
import script from "./blogWrappers.vue?vue&type=script&lang=js"
export * from "./blogWrappers.vue?vue&type=script&lang=js"

import "./blogWrappers.vue?vue&type=style&index=0&id=0b0075b3&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0075b3"]])

export default __exports__